import { Info } from "@ellaandil/ui";
import { clsx } from "@trydig/ui";
import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef } from "react";

const priceVariants = cva("flex shrink-0", {
	variants: {
		variant: {
			horizontal: "flex-row items-center gap-grid-component-spacing-3xs",
			vertical: "flex-col items-start gap-grid-component-spacing-none",
		},
	},
	defaultVariants: { variant: "horizontal" },
});

type PriceProps = VariantProps<typeof priceVariants> & {
	price: string;
	originalPrice?: string;
	showInfoButton?: boolean;
	className?: string;
	darkMode?: boolean;
};

export const Price = forwardRef<HTMLDivElement, PriceProps>(
	({ price, originalPrice, showInfoButton, variant = "horizontal", className, darkMode }, ref) => {
		return (
			<div ref={ref} className={clsx(priceVariants({ variant }), className)}>
				<span
					className={clsx(
						"font-body font-regular text-xs leading-[1.5] text-text-dark-text-1 whitespace-nowrap",
						darkMode && "text-text-light-text-1",
					)}
				>
					{price}
				</span>

				{originalPrice && (
					<span
						className={clsx(
							"font-body font-regular text-xs leading-[1.5] text-text-dark-text-2 line-through whitespace-nowrap",
							variant === "vertical" && "flex items-center gap-grid-grid-gutter-xs",
							darkMode && "text-text-light-text-1",
						)}
					>
						{originalPrice}
						{variant === "vertical" && showInfoButton && (
							<button
								type="button"
								className="inline-flex size-5 shrink-0 items-center justify-center rounded-component-specific-button bg-transparent"
							>
								<Info className="size-3.5 text-text-dark-text-2" />
							</button>
						)}
					</span>
				)}

				{variant === "horizontal" && showInfoButton && (
					<button
						type="button"
						className="flex size-5 shrink-0 items-center justify-center rounded-component-specific-button bg-transparent"
					>
						<Info
							className={clsx(
								"size-3.5 text-text-dark-text-2",
								darkMode && "text-text-light-text-1",
							)}
						/>
					</button>
				)}
			</div>
		);
	},
);

Price.displayName = "Price";
